import type { VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { pullVercelEnvValue } from '../env-pull.js'
import { readBlobTokenFromDotenv } from './read-blob-token-from-dotenv.js'

export function pullBlobToken(
  runner: VercelRunner,
  cwd: string,
  env?: NodeJS.ProcessEnv
): Promise<string | undefined> {
  return pullVercelEnvValue(runner, cwd, readBlobTokenFromDotenv, env)
}
